"use strict";

module.exports = function parseTableNumbers(transaction) {
  var sizeText = transaction.title.match(/\dx\d/);
  var product_size = '';

  if (sizeText && sizeText.length > 0) {
    product_size = sizeText[0];
  }

  var ink_color;
  var quantity;
  transaction.variations.forEach(function (_ref) {
    var formatted_value = _ref.formatted_value;

    if (formatted_value.match(/Set of/)) {
      quantity = parseFloat(formatted_value.replace('Set of ', ''), 10);
    } else {
      ink_color = formatted_value ? [formatted_value] : null;
    }
  });
  this.ink_colors = ink_color;
  this.tableNumbers.add({
    quantity: quantity,
    product_size: product_size
  }); // etsy table numbers are supposed to be on White Shimmer paper

  this.paper_type = 'White Shimmer';
};